import React from 'react'

import { Disclosure } from '@cred/react-disclosures-sdk'

const disclamers = {
  ups: <Disclosure required={false} slug="personal.dashboard.upstart" />,
  pro: <Disclosure required={false} slug="personal.dashboard.prosper" />,
  frp: <Disclosure required={false} slug="personal.dashboard.freedomplus" />,
  marlette: <Disclosure required={false} slug="personal.dashboard.marlette" />,
  lightstream: <Disclosure required={false} slug="personal.dashboard.lightstream" />,
  upgrade: <Disclosure required={false} slug="personal.dashboard.upgrade" />,
  'lending-point': <Disclosure required={false} slug="personal.dashboard.lendingpoint" />,
  ldc: <Disclosure required={false} slug="personal.dashboard.lendingclub" />,
  payoff: <Disclosure required={false} slug="personal.dashboard.payoff" />,
  axos: <Disclosure required={false} slug="personal.dashboard.axos" />,
  sofi: <Disclosure required={false} slug="personal.dashboard.sofi" />,
  ava: <Disclosure required={false} slug="personal.dashboard.avant" />,
  reach: <Disclosure required={false} slug="personal.dashboard.reach" />,
  'pl-discover': <Disclosure required={false} slug="personal.dashboard.discover" />,
  penfed: <Disclosure required={false} slug="personal.dashboard.penfed" />,
  'one-main': <Disclosure required={false} slug="partners-widgets.personal.disclaimer.one-main" />,
  tally: <Disclosure required={false} slug="personal.dashboard.tally" />,
  'universal-credit': <Disclosure required={false} slug="personal.dashboard.universalcredit" />,
  zable: <Disclosure required={false} slug="personal.dashboard.zable" />,
  bhg: <Disclosure required={false} slug="personal.dashboard.bhg" />,
  splash: <Disclosure required={false} slug="personal.dashboard.splash" />,
  sixtyml: <Disclosure required={false} slug="personal.dashboard.60monthloans" />,
  'lending-usa': <Disclosure required={false} slug="personal.dashboard.lending-usa" />,
  citi: <Disclosure required={false} slug="personal.dashboard.citi" />,
  reprise: <Disclosure required={false} slug="personal.dashboard.reprise" />,
  rocket: <Disclosure required={false} slug="personal.dashboard.rocket" />,
  santander: <Disclosure required={false} slug="personal.dashboard.santander" />,
  jenius: <Disclosure required={false} slug="personal.dashboard.jenius" />,
}

export default disclamers
